import { createContext, useContext, useEffect, useState } from "react";
import { api, appApi } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = logged out

  useEffect(() => {
    const token = localStorage.getItem("sz_token");
    if (!token) {
      setUser(false);
      return;
    }
    appApi
      .get("auth/me")
      .then(setUser)
      .catch(() => {
        localStorage.removeItem("sz_token");
        setUser(false);
      });
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("sz_token", data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("sz_token");
    setUser(false);
  };

  const refreshUser = async () => {
    const u = await appApi.get("auth/me");
    setUser(u);
    return u;
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
